import { PaletteOptions } from '@mui/material/styles/createPalette'

export enum TimeOfDay {
	MORNING = 'morning',
	AFTERNOON = 'afternoon',
	EVENING = 'evening',
}

export enum TIME_FORMATS {
	YEAR = 'year',
	MONTH = 'month',
	DAY = 'day',
	WEEK = 'week',
}

export type PaletteColors = keyof Omit<
	PaletteOptions,
	| 'mode'
	| 'tonalOffset'
	| 'contrastThreshold'
	| 'common'
	| 'grey'
	| 'text'
	| 'divider'
	| 'action'
	| 'background'
	| 'getContrastText'
>

export type AsyncFunction<Type = void> = () => Promise<Type>

export type Timers =
	| 'call'
	| 'note'
	| 'app-message'
	| 'chat'
	| 'checklist'
	| 'sms'

export type ObjectEntries<T> = Array<[string, Array<T>]>

export type DayTime = 'morning' | 'noon' | 'afternoon' | 'evening'

export interface DayTimeData {
	id: DayTime
	label: string
	iconType: DayTime
}

export type JSONValue =
	| string
	| number
	| boolean
	| JSONObject
	| Array<JSONValue>
	| null

export interface JSONObject {
	[key: string]: JSONValue
}

export enum PARTS_OF_DAY {
	MORNING = 'morning',
	NOON = 'noon',
	AFTERNOON = 'afternoon',
	EVENING = 'evening',
}

export enum DAYS_SHORT_NAMES {
	MON = 'monday',
	TUE = 'tuesday',
	WED = 'wednesday',
	THU = 'thursday',
	FRI = 'friday',
	SAT = 'saturday',
	SUN = 'sunday',
}

export enum CONTACT_METHODS {
	CALL = 'call',
	EMAIL = 'email',
}

export enum ENGAGE_STATUS {
	CONNECTED = 'connected',
	DISCONNECTED = 'disconnected',
	PENDING = 'pending',
	DENIED = 'denied',
}

export enum DIABETES_TYPES {
	TYPE_1 = 'type1',
	TYPE_2 = 'type2',
	GESTATIONAL = 'gestational',
	PRE_DIABETES = 'pre-diabetes',
	NONE = 'none',
	LATENT_AUTOIMMUNE_DIABETES = 'latent autoimmune diabetes',
	MONOGENIC_DAIBETES = 'monogenic diabetes',
	DISEASES_EXOCRINE_PANCREAS = 'diseases exocrine pancreas',
	CHEMICALLY_INCLUDED_DIABETES = 'chemically induced diabetes',
	OTHER = 'other',
	NOT_SURE = 'not sure',
}

export enum GENDERS {
	MALE = 'male',
	FEMALE = 'female',
	OTHER = 'other',
}

export enum AGE_GROUPS {
	UNDER_18 = 'Under 18',
	BETWEEN_19_44 = '19-44',
	BETWEEN_45_64 = '45-64',
	MORE_65 = '65+',
}

export enum LANGUAGES_SHORT {
	ENG = 'eng',
	ES = 'es',
	FR = 'fr',
}

export enum LANGUAGES_FULL {
	ENG = 'english',
	ES = 'spanish',
	FR = 'french',
}

export enum COMORBIDITIES {
	KIDNEY_DISEASE = 'kidney-disease',
	CARDIOVASCULAR = 'cardiovascular',
	HIGH_BLOOD_LYPIDS = 'high-blood-lypids',
	HYPERTENSION = 'hypertension',
	SLEEP_DISORDER = 'sleep-disorder',
}

export enum LAST_ACTIVITIES_TIME_RANGES {
	LAST_WEEK = 'last_week',
	LAST_2_WEEKS = 'last_2_weeks',
	LAST_MONTH = 'last_month',
	MORE_THAN_3_MONTHS = 'more_than_3_months',
}

export enum COUNTRIES {
	USA = 'us',
	CANADA = 'Ca',
	AUSTRALIA = 'Au',
}

export enum PMPM_STATUSES {
	CANCELLED = 'cancelled',
	ENROLLED = 'enrolled',
	FAILED = 'failed',
}

export enum REMINDER_VALUES {
	AT_THE_TIME_OF_DUE_DATE = 0,
	FIVE_MINUTES = 5,
	TEN_MINUTES = 10,
	FIFTEEN_MINUTES = 15,
	THIRTY_MINUTES = 30,
	FORTY_MINUTES = 45,
	ONE_HOUR = 60,
	TWO_HOURS = 120,
	ONE_DAY = 1440,
	TWO_DAYS = 2880,
	NO_REMINDER = -1,
}

export enum CLINIC_STATUS {
	INTERNAL = 'internalClinic',
	EXTERNAL = 'externalClinic',
}

export enum MEAL_TYPES {
	PRE_MEAL,
	POST_MEAL,
	GENERAL,
	BED_TIME,
	FASTING,
	ALL_MEALS,
}
